<template>
    <div class="tournament-sub-content" @click="$router.push(`/tournament/${tournament.tnmtId}`)">
        <div class="tournament-thumbnail" @click="$router.push(`/tournament/${tournament.tnmtId}`)"
             :style="{backgroundImage: `url('${tournament.posterImgPath}')`}"/>
        <div class="tournament-info">
            <p class="tournament-title">{{tournament.tnmtName}}</p>
            <div class="tournament-date">
                <span class="title">접수기간</span>
                <span class="date">{{changeDateFormat(tournament.enrollStartDate)}} - {{changeDateFormat(tournament.enrolEndDate)}}</span>

            </div>
            <div class="tournament-date">
                <span class="title">대회기간</span>
                <span class="date">{{changeDateFormat(tournament.startDate)}} - {{changeDateFormat(tournament.endDate)}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        props:['tournament']
    }
</script>